import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import React, { useState } from "react";
import { FacebookShareButton, FacebookIcon, TwitterShareButton } from "react-share";
import { FaInstagram } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import xLogo from "../../images/X-logo.png";

// Shares a dynamic link + win text (same model as Refer a Friend).
// Facebook & X use react-share web intents. Instagram has no web share intent,
// so it copies the text+link and opens instagram.com (the common fallback).
const StreakShare = ({
  url = "https://coin.spinsagacasino.com",
  title,
  onCopied,
}) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const shareTitle = title === undefined ? t('streak.shareDefaultTitle') : title;

  const flagCopied = () => {
    setCopied(true);
    if (onCopied) onCopied();
    setTimeout(() => setCopied(false), 3000);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(`${shareTitle} ${url}`);
    flagCopied();
  };

  const handleInstagram = () => {
    navigator.clipboard.writeText(`${shareTitle} ${url}`);
    flagCopied();
    window.open("https://www.instagram.com", "_blank", "noopener,noreferrer");
  };

  const igBtn = {
    width: 44,
    height: 44,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    color: "#fff",
    background:
      "radial-gradient(circle at 30% 110%, #fdf497 0%, #fd5949 45%, #d6249f 60%, #285AEB 90%)",
  };

  return (
    <Box sx={{ textAlign: "center" }}>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1.5 }}>
        <FacebookShareButton url={url} quote={shareTitle}>
          <FacebookIcon size={44} round />
        </FacebookShareButton>

        <TwitterShareButton url={url} title={shareTitle}>
          <img
            src={xLogo}
            alt={t('streak.shareXAlt')}
            style={{ height: 44, width: 44, borderRadius: "50%" }}
          />
        </TwitterShareButton>

        <Tooltip title={t('streak.shareCopyOpenInstagram')}>
          <Box onClick={handleInstagram} sx={igBtn}>
            <FaInstagram size={24} />
          </Box>
        </Tooltip>

        <Tooltip title={copied ? t('streak.shareCopied') : t('streak.shareCopyLink')}>
          <IconButton
            onClick={handleCopy}
            sx={{
              width: 44,
              height: 44,
              background: "rgba(255,255,255,0.12)",
              color: "#fff",
              "&:hover": { background: "rgba(255,255,255,0.22)" },
            }}
          >
            <ContentCopyIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>

      {copied && (
        <Typography sx={{ color: "#4caf50", fontSize: "12px", mt: 1 }}>
          {t('streak.shareCopiedHint')}
        </Typography>
      )}
    </Box>
  );
};

export default StreakShare;
